import * as VehiclesModule from 'Modules/VehiclesModule';
import { AxiosPromise } from 'axios';
import API, { config } from './_main';
import {IPaginatedList} from "Models/PaginatedList";

export function getRideHistory(params: URLSearchParams) {
    return API.get('history/ride', config(params));
}

export function getRideDetails(carRideId: number) {
    return API.get(`history/ride/${carRideId}`, config());
}

export function getTodaysRide(carId: number) {
    return API.get(`history/${carId}/today`, config());
}

export function getLatestDataframes(carId: number, params: URLSearchParams): AxiosPromise<{ dataframes: IPaginatedList<VehiclesModule.Types.CarDataframeDto> }> {
    return API.get(`history/${carId}/dataframes`, config(params));
}



// WEBPACK FOOTER //
// ./src/Connectors/HistoryConnector.ts